{
  "name": "login-ui",
  "version": "2.11.2",
  "description": "",
  "scripts": {
    "start": "parcel serve ./src/index.html",
    "start-no-cache": "parcel serve --no-cache ./src/index.html ",
    "build": "parcel build --no-autoinstall --public-url \"${BASE_URL:-.}/\" ./src/index.html",
    "lint": "eslint",
    "lint:fix": "yarn lint --fix",
    "lint:staged": "lint-staged",
    "clean": "echo \"No clean command in login-ui\"",
    "test": "jest",
    "test:clear-cache": "cross-env NODE_ENV=test jest --clearCache",
    "test:watch": "cross-env NODE_ENV=test jest --watchAll",
    "test:update-snapshots": "jest -u",
    "precommit": "lint-staged",
    "refmt": "prettier --write src/",
    "ci": "yarn lint && yarn test && yarn build"
  },
  "keywords": [],
  "author": {
    "name": "McK/ID Core Team",
    "email": "mckid_core@mckinsey.com"
  },
  "license": "UNLICENSED",
  "engines": {
    "node": "^18 || >=20"
  },
  "dependencies": {
    "@mds/mds-icons": "^0.9.1",
    "@mds/mds-reactjs-library": "2.0.0",
    "jose": "4.15.9",
    "qs": "6.11.2",
    "react": "16.14.0",
    "react-dom": "16.14.0",
    "react-router-dom": "5.3.4",
    "sanitize.css": "13.0.0",
    "styled-components": "6.0.7"
  },
  "devDependencies": {
    "@babel/core": "7.22.11",
    "@babel/plugin-proposal-class-properties": "^7.18.6",
    "@babel/plugin-transform-react-constant-elements": "7.22.5",
    "@babel/plugin-transform-react-inline-elements": "7.22.5",
    "@babel/plugin-transform-runtime": "7.22.10",
    "@babel/preset-env": "7.22.14",
    "@babel/preset-react": "7.22.5",
    "@babel/preset-typescript": "7.22.11",
    "@testing-library/jest-dom": "5.17.0",
    "@testing-library/react": "10.4.9",
    "@types/jest": "25.2.3",
    "@types/node": "18.17.12",
    "@types/qs": "6.9.8",
    "@types/react": "16.14.46",
    "@types/react-dom": "16.9.19",
    "@typescript-eslint/eslint-plugin": "5.62.0",
    "@typescript-eslint/parser": "5.62.0",
    "babel-plugin-styled-components": "2.1.4",
    "buffer": "6.0.3",
    "cross-env": "5.2.1",
    "crypto-browserify": "3.12.0",
    "dotenv": "8.6.0",
    "eslint": "7.32.0",
    "eslint-config-prettier": "6.15.0",
    "eslint-plugin-prettier": "3.4.1",
    "eslint-plugin-react": "7.33.2",
    "events": "3.3.0",
    "jest": "25.5.4",
    "jest-transform-stub": "2.0.0",
    "lint-staged": "7.3.0",
    "parcel": "2.9.3",
    "posthtml": "0.16.6",
    "posthtml-expressions": "1.11.1",
    "prettier": "2.8.8",
    "stream-browserify": "3.0.0",
    "ts-jest": "25.5.1",
    "typescript": "3.9.10",
    "util": "0.12.5"
  },
  "alias": {
    "buffer": "buffer",
    "crypto": "crypto-browserify",
    "events": "events",
    "process": false,
    "stream": "stream-browserify",
    "util": "util/util.js"
  },
  "targets": {
    "default": {
      "engines": {
        "browsers": "> 1%, last 2 versions, not dead"
      }
    }
  },
  "browserslist": "> 1%, last 2 versions, not dead"
}
